import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Course from 'models/Course';
import CourseCategory from 'models/CourseCategory';

import { LIST_MARKUP } from 'consts/api';
import { fillPage } from 'utils/translations';

import { list as listCourseCategories } from 'requests/courseCategories';
import { list as listCourses } from 'requests/courses';

import Component from './component';
import { Props } from './types';

export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<Props>> {
    let courseCategories: ListCollection<CourseCategory> = LIST_MARKUP;
    let courses: ListCollection<Course> = LIST_MARKUP;
    const initialLeadId: string = context?.query?.leadId?.toString();

    try {
        await Promise.all([
            listCourseCategories({ page: 1, perPage: 999 }),
            listCourses({
                page: 1,
                perPage: 6,
                search: context.query?.search?.toString(),
                categoryId: context.query?.categoryId?.toString(),
                leadId: initialLeadId,
            }),
        ]).then(responses => {
            courseCategories = responses[0]?.courseCategories;
            courses = responses[1]?.courses;
        });
    } catch (error) {
        console.error(error);
    }

    let pageTranslations = JSON.parse(JSON.stringify(require('locales/pl/pages/courses')?.default));
    const fillValues = {};
    pageTranslations = fillPage(pageTranslations, null, fillValues);

    return {
        props: {
            pageTranslations,
            courseCategories: JSON.parse(JSON.stringify(courseCategories)),
            courses: JSON.parse(JSON.stringify(courses)),
            initialLeadId: initialLeadId ? initialLeadId : null,
        },
    };
}

export default Component;

